import { render, staticRenderFns } from "./widget-dato.vue?vue&type=template&id=724ff198&scoped=true&"
import script from "./widget-dato.vue?vue&type=script&lang=js&"
export * from "./widget-dato.vue?vue&type=script&lang=js&"
import style0 from "./widget-dato.vue?vue&type=style&index=0&id=724ff198&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724ff198",
  null
  
)

export default component.exports